const ACTION = 'MATCHED_ITEMS_GET';

const actionCreator = () => ({ type: ACTION });

actionCreator.ACTION = ACTION;

export default actionCreator;


// WEBPACK FOOTER //
// ./src/Menu/ActionCreator/getMatchedItemsAction.js